












































import updateClassSidebar from "@/mixin/updateClassSidebar.ts";
import User from "@/model/user";
import vClickOutside from "v-click-outside";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
const auth = namespace("Auth");

@Component({
  name: "QSidebarAadminCustomer",
  directives: {
    clickOutside: vClickOutside.directive,
  },
})
export default class QSidebarAadminCustomer extends Mixins(updateClassSidebar) {
  @auth.Getter
  public getUserType!: (token: string) => void;

  public classPage: any[] = ["mb__admin-navbox"];

  public User = new User();

  public created() {
    this.getClassPage();
  }

  @Watch("$route.currentRoute", { deep: true, immediate: true })
  public changeCurrentRoute() {
    this.getClassPage();
  }

  public getClassPage() {
    const newClass = ["mb__admin-navbox"];

    if (this.$router.currentRoute.meta.className) {
      newClass.push(this.$router.currentRoute.meta.className);
    }
    this.classPage = newClass;
  }
  public async logout() {
    // try {
    //   const result = await userApi.logout();
    //   if (result.status === 200) {
    //     store.dispatch("Auth/logout");
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  }

  public closeMenu(event) {
    this.$emit("closeMenu", event);
  }
}
